import { render } from "./Ori.vue?vue&type=template&id=44a94c2e&scoped=true"
import script from "./Ori.vue?vue&type=script&lang=js"
export * from "./Ori.vue?vue&type=script&lang=js"

import "./Ori.vue?vue&type=style&index=0&id=44a94c2e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a94c2e"]])

export default __exports__